import type { FBSContainerListResponse } from "@/shared/generated/ExpHubApi";

export interface Address {
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
  country?: string;
}

export const mapToAddressType = (
  data: FBSContainerListResponse["containers"][number]["address"] | undefined,
): Address => {
  return {
    street: data?.street,
    houseNumber: data?.houseNumber,
    postalCode: data?.postCode,
    city: data?.city,
    country: data?.countryCode,
  };
};
